// extracted by mini-css-extract-plugin
export default {"root":"page-content_root__EHGh8"};